import React from "react";

export default function StructuredData({ data }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Bill Forge",
  "url": "https://billforge.codingwithdevam.cloud",
  "logo": "https://billforge.codingwithdevam.cloud/logo.svg",
  "description": "Simple, powerful invoicing for your business. Create professional invoices, manage customers, track inventory, and grow your business with Bill Forge.",
  "contactPoint": {
    "@type": "ContactPoint",
    "email": "info@codingwithdevam.cloud",
    "contactType": "customer service"
  }
};

export const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Bill Forge",
  "url": "https://billforge.codingwithdevam.cloud",
  "description": "Simple, powerful invoicing for your business. Create professional invoices, manage customers, track inventory, and grow your business with Bill Forge.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://billforge.codingwithdevam.cloud/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});